import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ComparisonPage from "@/pages/comparison/page";
import SecurityPage from "@/pages/security/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul-kakobuy-sheet",
    element: <ArticlePage />,
  },
  {
    path: "/porownanie-kakobuy-cssbuy",
    element: <ComparisonPage />,
  },
  {
    path: "/bezpieczenstwo-kakobuy",
    element: <SecurityPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;